import { createContext, useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { ConfirmData } from '../types/confirm/confirm'

type ConfirmContextType = {
  confirm: (data: ConfirmData, path?: string) => void
  confirmData: ConfirmData | null
  clearConfirm: () => void
}

const ConfirmContext = createContext<ConfirmContextType | null>(null)

export const useConfirm = () => useContext(ConfirmContext)!

export const ConfirmProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const navigate = useNavigate()
  const [confirmData, setConfirmData] = useState<ConfirmData | null>(null)

  const confirm = (data: ConfirmData, path = '/confirm') => {
    setConfirmData(data)
    navigate(path)
  }

  const clearConfirm = () => {
    setConfirmData(null)
  }

  return (
    <ConfirmContext.Provider
      value={{
        confirm,
        confirmData,
        clearConfirm,
      }}
    >
      {children}
    </ConfirmContext.Provider>
  )
}
